import { Language, TranslationGenerationType } from '@data/sdk/match';

type Translation = { generationType: TranslationGenerationType; language: Language; value: string };

export const translationsToFormValues = (translations: Translation[]) =>
  translations.reduce<{ [key in Language]: string }>(
    (acc: { [key in Language]: string }, el: Translation) => {
      acc[el.language as Language] = el.value;
      return acc;
    },
    { de: '', en: '', fr: '', nl: '', cs: '', es: '', it: '', pt: '', pl: '' },
  );
